<template>
	<div class="relative app-container min-h-screen bg-slate-200">
		<header v-if="!appStore.isLoading">
			<AppNavbar v-if="showNavbar" :navigation="showSidebar" />
			<AppDriverBar v-if="showDriverBar" />
		</header>

		<div class="main">
			<div class="flex">
				<!-- sidebar -->
				<AppSidebar v-if="showSidebar && $route.name" :key="$route.fullPath" />

				<!-- router view -->
				<div class="content min-w-0 grow overflow-visible p-4 sm:p-6">
					<RouterView></RouterView>
				</div>
			</div>
		</div>

		<toaster />
		<loader />
	</div>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'
	import { useRoute } from 'vue-router'
	import useAppStore from './stores/app'
	import useAuthStore from '@/stores/auth'
	import Loader from './components/layout/core/Loader.vue'
	import AppDriverBar from './components/layout/navbar/AppDriverBar.vue'

	const appStore = useAppStore()
	const authStore = useAuthStore()

	const route = useRoute()

	const showNavbar = computed(() => {
		return authStore.user && !appStore.fullscreen
	})

	const showSidebar = computed(() => {
		const hasNavigation = route.meta.navigation !== false
		return authStore.user && hasNavigation && !appStore.fullscreen
	})

	const showDriverBar = computed(() => {
		return authStore.user && route.meta.driverBar
	})
</script>
